import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'

const index = () => import('../pages/index/index')
const changepassword = () => import('../pages/changepassword/changepassword')
const userinfo = () => import('../pages/userinfo/index')

const student_signup = () => import('../pages/student/signup')
const student_nursing = () => import('../pages/student/signup/nursing.vue')
const student_physician = () => import('../pages/student/signup/physician.vue')
const student_checkin = () => import('../pages/student/checkin')
const student_graduation = () => import('../pages/student/graduation')
const student_refund = () => import('../pages/student/refund')
const student_reject = () => import('../pages/student/signup/reject.vue')
const student_zkzx = () => import('../pages/student/zkzx.vue')
const student_agreementUnit = () => import('../pages/student/agreementUnit.vue')
const student_headNurse = () => import('../pages/student/headNurse.vue')
const assign_assignTeacher = () => import('../pages/assign/assignTeacher.vue')
const assign_assignTeacherHL = () => import('../pages/assign/assignTeacherHL.vue')
const assign_bqhsz = () => import('../pages/assign/bqhsz.vue')
const graduation_physician = () => import('../pages/student/graduation/physician.vue')
const graduation_nursing = () => import('../pages/student/graduation/nursing.vue')
const library = () => import('../pages/student/library.vue')
const student_checkin_physician = () => import('../pages/student/checkin/physician.vue')
const student_checkin_nursing = () => import('../pages/student/checkin/nursing.vue')

const jointApproval_zkzxApproval = () => import('../pages/jointApproval/zkzxApproval.vue')
const jointApproval_tsgApproval = () => import('../pages/jointApproval/tsgApproval.vue')

const data_signup = () => import('../pages/data/signup')
const data_education = () => import('../pages/data/education')
const data_index = () => import('../pages/data/index')

const admin_user = () => import('../pages/admin/user')
const admin_role = () => import('../pages/admin/role')
const admin_dictionaries = () => import('../pages/admin/dictionaries')
const admin_fee = () => import('../pages/admin/fee')
const admin_nursingFee = () => import('../pages/admin/nursingFee')
const admin_log = () => import('../pages/admin/log')
const admin_hospitalType = () => import('../pages/admin/hospitalType')
const admin_broadcast = () => import('../pages/admin/broadcast')
const admin_schoolCompanyApply = () => import('../pages/admin/schoolCompanyApply')
const admin_nextWeek = () => import('../pages/admin/nextWeek')
const admin_userFiles = () => import('../pages/admin/userFiles')

const flow_config = () => import('../pages/flow/config')

const error404 = () => import('../pages/error-page/404')
const login = () => import('../pages/login/login')
const register = () => import('../pages/login/register')
const forget = () => import('../pages/login/forget')

const erweima = () => import('../pages/erweima/erweima')
const prove = () => import('../pages/prove/prove')


const export_index = () => import('../pages/export/index')

const update_index = () => import('../pages/update/index')

const publicize_dept = () => import('../pages/publicize/dept')
const publicize_approval = () => import('../pages/publicize/approval')
const publicize_my = () => import('../pages/publicize/my')
const publicize_myApply = () => import('../pages/publicize/myApply')



//web
const web = () => import('../pages/web/home.vue')
const room_index = () => import('../pages/web/room/index.vue')
const me_index = () => import('../pages/web/me/index.vue')
const web_student_nursing = () => import('../pages/web/student/signup/nursing.vue')
const web_student_physician = () => import('../pages/web/student/signup/physician.vue')
const web_student_checkin = () => import('../pages/web/student/checkin')
const web_graduation_physician = () => import('../pages/web/student/graduation/physician.vue')
const web_graduation_nursing = () => import('../pages/web/student/graduation/nursing.vue')
const web_student_assignTeacher = () => import('../pages/web/student/assignTeacher.vue')
const web_student_jointApproval = () => import('../pages/web/student/jointApproval.vue')
const web_jointApproval_zkzxApproval = () => import('../pages/web/jointApproval/zkzxApproval.vue')
const web_jointApproval_tsgApproval = () => import('../pages/web/jointApproval/tsgApproval.vue')
const web_admin_schoolCompanyApply = () => import('../pages/web/admin/schoolCompanyApply')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/erweima',
      name: 'erweima',
      component: erweima,
      meta: {
        title: '报到确认',
      }
    },
    {
      path: '/prove',
      name: 'prove',
      component: prove,
      meta: {
        title: '上传结业鉴定书',
      }
    },
    {
      path: '*',
      name: 'error404',
      component: error404,
      meta: {
        title: '404',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '登录',
      }
    },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: register,
    //   meta: {
    //     title: '注册',
    //   }
    // },
    {
      path: '/forget',
      name: 'forget',
      component: forget,
      meta: {
        title: '忘记密码',
      }
    },
    {
      path: '/',
      name: 'Home',
      component: home,
      redirect:'/index',
      children:[
        {
          path: 'index',
          component: index,
          meta: {
            title: '首页',
          }
        },{
          path: 'changepassword',
          component: changepassword,
          meta: {
            title: '修改密码',
          }
        },{
          path: 'userinfo',
          component: userinfo,
          meta: {
            title: '个人资料',
          }
        },{
          path: 'admin/user',
          component: admin_user,
          meta: {
            title: '用户管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/role',
          component: admin_role,
          meta: {
            title: '权限管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/dictionaries',
          component: admin_dictionaries,
          meta: {
            title: '字典管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/signup',
          component: student_signup,
          meta: {
            title: '进修申请审核',
            roles: ['admin'],
            requireAuth: true
          },
        },{
          path: 'student/checkin',
          component: student_checkin,
          meta: {
            title: '报到管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/graduation',
          component: student_graduation,
          meta: {
            title: '进修管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/refund',
          component: student_refund,
          meta: {
            title: '退款管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'data/index',
          component: data_index,
          meta: {
            title: '数据统计',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'data/signup',
          component: data_signup,
          meta: {
            title: '报名报到统计',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'data/education',
          component: data_education,
          meta: {
            title: '进修统计',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/fee',
          component: admin_fee,
          meta: {
            title: '报名费用管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/nursingFee',
          component: admin_nursingFee,
          meta: {
            title: '护理部费用管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/log',
          component: admin_log,
          meta: {
            title: '日志管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/signup/physician',
          component: student_physician,
          meta: {
            title: '医师医技进修申请审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/signup/nursing',
          component: student_nursing,
          meta: {
            title: '护理进修申请审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/signup/reject',
          component: student_reject,
          meta: {
            title: '审核不通过数据',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/hospitalType',
          component: admin_hospitalType,
          meta: {
            title: '单位管理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/broadcast',
          component: admin_broadcast,
          meta: {
            title: '消息广播',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/zkzx',
          component: student_zkzx,
          meta: {
            title: '制卡中心',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/agreementUnit',
          component: student_agreementUnit,
          meta: {
            title: '协议单位进修生',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/schoolCompanyApply',
          component: admin_schoolCompanyApply,
          meta: {
            title: '学校/单位审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'flow/config',
          component: flow_config,
          meta: {
            title: '流程配置',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'assign/assignTeacher',
          component: assign_assignTeacher,
          meta: {
            title: '分配指导老师',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'assign/assignTeacherHL',
          component: assign_assignTeacherHL,
          meta: {
            title: '分配指导老师',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'assign/bqhsz',
          component: assign_bqhsz,
          meta: {
            title: '分配病区护士长',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/headNurse',
          component: student_headNurse,
          meta: {
            title: '分配科室护士长',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'jointApproval/zkzxApproval',
          component: jointApproval_zkzxApproval,
          meta: {
            title: '制卡中心审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'jointApproval/tsgApproval',
          component: jointApproval_tsgApproval,
          meta: {
            title: '图书馆审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/graduation/physician',
          component: graduation_physician,
          meta: {
            title: '医师医技',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/graduation/nursing',
          component: graduation_nursing,
          meta: {
            title: '护理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/library',
          component: library,
          meta: {
            title: '图书卡审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'export/index',
          component: export_index,
          meta: {
            title: '数据导出',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/nextWeek',
          component: admin_nextWeek,
          meta: {
            title: '下周待办',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/checkin/physician',
          component: student_checkin_physician,
          meta: {
            title: '医师医技',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'student/checkin/nursing',
          component: student_checkin_nursing,
          meta: {
            title: '护理',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'update/index',
          component: update_index,
          meta: {
            title: '修改数据审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'admin/userFiles',
          component: admin_userFiles,
          meta: {
            title: '学生文件数据',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'publicize/dept',
          component: publicize_dept,
          meta: {
            title: '宣传科室',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'publicize/approval',
          component: publicize_approval,
          meta: {
            title: '内容审核',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'publicize/my',
          component: publicize_my,
          meta: {
            title: '我负责的',
            roles: ['admin'],
            requireAuth: true
          }
        },{
          path: 'publicize/myApply',
          component: publicize_myApply,
          meta: {
            title: '我提交的',
            roles: ['admin'],
            requireAuth: true
          }
        }
      ]
    },
    {
      path: '/web',
      name: 'web',
      component: web,
      children:[
        {
          path: 'room/index',
          component: room_index,
          meta: {
            title: '工作台',
          }
        },
        {
          path: 'me/index',
          component: me_index,
          meta: {
            title: '个人',
          }
        },
      ]
    },
    {
      path: '/web/student/signup/nursing',
      name: 'web_student_nursing',
      component: web_student_nursing,
      meta: {
        title: '报名审核(医师医技)',
      }
    },
    {
      path: '/web/student/signup/physician',
      name: 'web_student_physician',
      component: web_student_physician,
      meta: {
        title: '报名审核(护理)',
      }
    },
    {
      path: '/web/student/checkin',
      name: 'web_student_checkin',
      component: web_student_checkin,
      meta: {
        title: '报到审核',
      }
    },
    {
      path: '/web/student/graduation/physician',
      name: 'web_graduation_physician',
      component: web_graduation_physician,
      meta: {
        title: '结业审核(医师医技)',
      }
    },
    {
      path: '/web/student/graduation/nursing',
      name: 'web_graduation_nursing',
      component: web_graduation_nursing,
      meta: {
        title: '结业审核(护理)',
      }
    },
    {
      path: '/web/student/assignTeacher',
      name: 'web_student_assignTeacher',
      component: web_student_assignTeacher,
      meta: {
        title: '分配指导老师',
      }
    },
    {
      path: '/web/student/jointApproval',
      name: 'web_student_jointApproval',
      component: web_student_jointApproval,
      meta: {
        title: '结业联合审核',
      }
    },
    {
      path: '/web/jointApproval/zkzxApproval',
      name: 'web_jointApproval_zkzxApproval',
      component: web_jointApproval_zkzxApproval,
      meta: {
        title: '制卡中心审核',
      }
    },
    {
      path: '/web/jointApproval/tsgApproval',
      name: 'web_jointApproval_tsgApproval',
      component: web_jointApproval_tsgApproval,
      meta: {
        title: '图书馆审核',
      }
    },
    {
      path: '/web/admin/schoolCompanyApply',
      name: 'web_admin_schoolCompanyApply',
      component: web_admin_schoolCompanyApply,
      meta: {
        title: '学校/单位审核',
      }
    },
  ],
  mode:"history",
  // base: '/jxs/',
})

// 捕获路由懒加载chunk错误
let hasReload = false // 防抖标记，防止反复刷新
router.onError((error) => {
  const pattern = /Loading chunk (\S)+ failed|ChunkLoadError/g
  const isChunkLoadFailed = pattern.test(error.message)
  if (isChunkLoadFailed && !hasReload) {
    hasReload = true
    if (confirm('系统已经更新，点击确定刷新页面加载新版本')) {
      window.location.reload()
    }
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js